import { Price } from '@jetshop/ui/Price';
import { styled } from 'linaria/react';

export const PreStyledPrice = styled(Price)`
  div::after {
    content: ',-';
  }
`;
